function getBrowserFullLocale(): string | undefined {
  const navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language;

  if (!navigatorLocale) {
    return undefined;
  }

  const trimmedLocale = navigatorLocale.trim().replace('-', '_'); // Normalise locale (en-GB -> en_GB)
  return trimmedLocale;
}

function getBrowserLocale(): string | undefined {
  const navigatorLocale = getBrowserFullLocale();

  if (!navigatorLocale) {
    return undefined;
  }

  const trimmedLocale = navigatorLocale.trim().split(/-|_/)[0];
  return trimmedLocale;
}

export { getBrowserLocale, getBrowserFullLocale };
